import { signal } from 'services/SignalsService'

const name = 'FREEBET-ADD'

async function execute() {
  return signal.promise('RADIO:FB')
}

export function getFreeBetAddAction() {
  return {
    name,
    execute,
  }
}
